export default "__VITE_ASSET__CvzMoeNQ__"